'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/isPrimitive.js
// module id = 227
// module chunks = 1